import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import LogoIcon from '../../common/LogoIcon';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLock, FiMail, FiInfo, FiArrowLeft } = FiIcons;

const Login = () => {
  // Hardcoded credentials as requested
  const ADMIN_EMAIL = 'admin@rvenue.com';
  const ADMIN_PASSWORD = 'admin123';

  const [email, setEmail] = useState(ADMIN_EMAIL);
  const [password, setPassword] = useState(ADMIN_PASSWORD);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Hardcoded check for administrative access
    setTimeout(() => {
      if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
        // Standardised key to match Dashboard.jsx checks
        localStorage.setItem('isAdmin', 'true');
        navigate('/admin');
      } else {
        setError('Invalid credentials. Please use the default admin login.');
        setLoading(false);
      }
    }, 800);
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center p-6">
      <div className="bg-white p-10 shadow-2xl w-full max-w-md border border-brand-olive/5 transition-all relative overflow-hidden">
        {/* Decorative Top Accent */}
        <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-olive" />
        
        <div className="text-center mb-10">
          <Link to="/" className="inline-block group">
            <LogoIcon className="w-20 h-20 mx-auto mb-6 rounded-full shadow-lg transition-transform duration-500 group-hover:scale-110 group-hover:rotate-[360deg]" />
          </Link>
          <h1 className="font-serif text-2xl uppercase tracking-widest text-brand-olive font-bold">Admin Console</h1>
          <p className="text-brand-olive/50 text-[10px] font-black uppercase tracking-widest mt-2">Internal Management Access</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-brand-olive/60">
              <SafeIcon icon={FiMail} /> Email Address
            </label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 bg-brand-cream/30 border border-brand-olive/10 focus:border-brand-olive outline-none transition-all text-brand-olive font-bold" required />
          </div>

          <div className="space-y-2">
            <label className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-brand-olive/60">
              <SafeIcon icon={FiLock} /> Password
            </label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 bg-brand-cream/30 border border-brand-olive/10 focus:border-brand-olive outline-none transition-all text-brand-olive font-bold" required />
          </div>

          {error && (
            <div className="p-4 bg-red-50 border-l-4 border-red-500 text-red-700 text-[10px] font-bold uppercase tracking-widest leading-relaxed">
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="w-full py-5 bg-brand-olive text-white font-bold uppercase tracking-[0.2em] text-xs transition-all duration-300 shadow-xl hover:bg-brand-dark hover:shadow-2xl active:scale-95 disabled:opacity-50">
            {loading ? 'Verifying...' : 'Sign In'}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-brand-olive/5 flex justify-center">
          <Link to="/" className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-brand-olive/40 hover:text-brand-olive transition-colors">
            <SafeIcon icon={FiArrowLeft} /> Back to Public Site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;